import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from "swiper";

import Template from '../templates/template';
import img_dummy from '../assets/images/dummy.png';

import NavigationBlock from '../components/navigation-block';

const Start = inject("stores") (
    observer (
        class Start extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.urlAPI = process.env.REACT_APP_URL_API;
                this.storeUi = this.props.stores.storeUi;    

                this.state = {
                    view: this.props.view,
                    swiper: 1
                }                          
            }

            componentDidMount = async() => {
                const slides_brands = await this.storeUi.getDataCarousel('brands');
                const slides_bridal = await this.storeUi.getDataCarousel('bridal');
                this.setState({
                    slides_brands: slides_brands,
                    slides_bridal: slides_bridal
                })

                this.alternateSliders();
            }

            handleBrands = (section) => {
                const url = "/" + section + "/";
                this.props.history.push(url);
            }

            alternateSliders = () => {
                const interval = setInterval(() => {
                    if (this.reactSwiper1 && this.reactSwiper2) {
                        this.state.swiper === 1 ? this.reactSwiper2.swiper().slideNext() : this.reactSwiper1.swiper().slideNext();

                        this.setState({
                            swiper: this.state.swiper === 1 ? 2 : 1
                        })

                    }
                }, 3500);
            }

            render() {
                return (
                    <Template>
                        <div className="container--content container--content-home">
                            <div className="container--navigation">
                                <div className="page__columns">
                                    <div className="page__column--start --left">
                                        <NavigationBlock
                                            section = "brands"
                                        />
                                        <div className="container--swiper">
                                            <Swiper 
                                                 spaceBetween={30}
                                                 centeredSlides={true}
                                                 autoplay={{
                                                   delay: 2500,
                                                   disableOnInteraction: false,
                                                 }}
                                                 pagination={{
                                                   clickable: true,
                                                 }}
                                                 navigation={true}
                                                 modules={[Autoplay]}
                                                 className="mySwiper"
                                            >
                                                {this.state.slides_brands && this.state.slides_brands.map((img, i) => (
                                                    <SwiperSlide key={i}>
                                                        <span 
                                                            onClick={() => this.handleBrands('brands')}
                                                            style={{ backgroundImage: `url(${this.urlAPI + "/adam/"+ img})` }}
                                                        />
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper> 
                                        </div> 
                                    </div>  
                                    {/* <div className="page__column--start --right">
                                        <div className="container--swiper" dir="rtl">
                                            <Swiper 
                                                ref={(c) => { this.reactSwiper2 = c }}
                                                autoplay={{
                                                    delay: 2500,
                                                    disableOnInteraction: false,
                                                  }}                                               
                                            >
                                                {this.state.slides_bridal && this.state.slides_bridal.map((img, i) => (
                                                    <SwiperSlide key={i}>
                                                        <span 
                                                            onClick={() => this.handleBrands('bridal')}
                                                            style={{ backgroundImage: `url(${this.urlAPI + "/adam/"+ img})` }}
                                                        />
                                                      </SwiperSlide>
                                                ))}
                                            </Swiper> 
                                        </div>
                                        <NavigationBlock
                                            section = "bridal"
                                        />
                                    </div> */}
                                </div>     
                            </div>            
                        </div>
                    </Template>
                );
            }
        }
    )
)

export default Start;
